import { Component, Input, OnInit } from '@angular/core';
import { ViewMode } from '../../../../models';
import { GiftUnlockPreviewMode } from '../../../extension-components/gift-unlock/gift-unlock.component';
import { GiftUnlockExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

@Component({
  selector: 'gift-unlock-example',
  templateUrl: './gift-unlock-example.component.html',
  styleUrls: ['./gift-unlock-example.component.scss'],
  standalone: false,
})
export class GiftUnlockExampleComponent implements OnInit {
  @Input() template;
  @Input() mode: ViewMode = null;
  @Input() previewMode: GiftUnlockPreviewMode = GiftUnlockPreviewMode.GiftBanner;
  @Input() isMobile: boolean = false;
  PreviewMode = GiftUnlockPreviewMode;
  OfferType = GiftUnlockExtension.OfferType;
  GiftMode = GiftUnlockExtension.GiftMode;
  ProductDisplayType = GiftUnlockExtension.ProductDisplayType;

  ngOnInit(): void {}

  get effectivePreviewMode(): GiftUnlockPreviewMode {
    if (this.mode) return this.previewMode;
    const giftMessageEnabled = this.template?.giftMessage?.enabled ?? true;
    if (giftMessageEnabled) return GiftUnlockPreviewMode.GiftBanner;
    const displayAsPopUp = this.template?.offer?.displayAsPopUp ?? true;
    return displayAsPopUp ? GiftUnlockPreviewMode.GiftPopup : GiftUnlockPreviewMode.GiftOffer;
  }

  get discountedPrice(): number {
    const originalPrice = 9.99;
    const discountValue = this.template?.settings?.productDetails?.discountConfiguration?.discountValue;
    const discountType = this.template?.settings?.productDetails?.discountConfiguration?.discountType;

    const amount =
      discountType === GiftUnlockExtension.CouponType.PERCENTAGE
        ? originalPrice - originalPrice * (discountValue / 100)
        : originalPrice - (discountValue || 0);
    return amount > 0 ? Number(amount.toFixed(2)) : 0;
  }

  get bannerStyleClasses(): Record<string, boolean> {
    const style = this.template?.giftMessageStyle;
    if (!style) return {};

    return {
      [`banner-border--${style.border}`]: !!style.border,
      [`banner-border-width--${style.borderWidth}`]: !!style.borderWidth,
      [`banner-corner-radius--${style.cornerRadius}`]: !!style.cornerRadius,
      [`banner-padding--${style.padding}`]: !!style.padding,
    };
  }

  get isCompactDisplay(): boolean {
    return this.template?.offer?.productDisplayType === GiftUnlockExtension.ProductDisplayType.COMPACT;
  }

  get offerProducts(): GiftUnlockExtension.OfferProduct[] {
    return this.template?.offer?.products ?? [];
  }

  get isSingleGiftMode(): boolean {
    return this.template?.offer?.giftMode !== GiftUnlockExtension.GiftMode.MULTIPLE;
  }

  get previewProducts(): { name: string; price: string }[] {
    const item = { name: 'Product name', price: '$9.99' };
    return this.isSingleGiftMode ? [item] : [item, { ...item }, { ...item }];
  }
}
